import { Container as MuiContainer, SxProps } from "@mui/material";
import { PropsWithChildren } from "react";

const Container = ({ children, sx }: PropsWithChildren<{ sx?: SxProps }>) => (
  <MuiContainer maxWidth="lg" sx={sx}>
    {children}
  </MuiContainer>
);

export default Container;
